import { Badge, Button, Flex, Space, Tooltip, Typography, theme } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

const LegacyArchiveMeetingPreviewCard = ({ item, onView }) => {
  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
    },
  } = theme.useToken();
  
  return (
    <Badge.Ribbon
      text="Archived (Old)"
      color="red"
      style={{ fontSize: "0.7em", lineHeight: "23px" }}
    >
      <div
        style={{
          marginBottom: 8,
          padding: '12px 12px',
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
          cursor: 'pointer',
        }}
      >
        <Flex justify='space-between' align='center' gap={16} style={{ minHeight: 76 }}>
          <Flex justify='start-flex' align='center' gap={16} style={{ width: '70%' }}>
            <Badge color="red" />
            <Flex vertical gap={8}>
              <Typography.Text>{item.title}</Typography.Text>
              <Typography.Text style={{ fontSize: 10 }}>
                {item.formattedDate}
                {item.formattedDate && item.formattedTime ? ' | ' : ''}
                {item.formattedTime}
              </Typography.Text>
            </Flex>
          </Flex>
          <div style={{ display: "flex", gap: 20, width: "30%", justifyContent: "flex-end" }}>
            <Space size="middle">
              <Tooltip title="View">
                <Button type="primary" icon={<EyeOutlined />} onClick={() => onView(item.raw)} />
              </Tooltip>
            </Space>
          </div>
        </Flex>
      </div>
    </Badge.Ribbon>
  );
};

export default LegacyArchiveMeetingPreviewCard;
